export const DATA_COLLECTION_ID = "data-collection-id";
export const DATA_COLLECTION_ITEM_ID = "data-collection-item-id";
export const DATA_COLLECTION_ITEM_FIELD = "data-collection-item-field";
export const DATA_COLLECTION_REFERENCE = "data-collection-reference";
export const DATA_ARR_INDEX = "data-arr-index";
export const DATA_ARR_VARIABLE_NAME = "data-arr-variable-name";
export const DATA_ARR_FIELD = "data-arr-field";

export const ALLOWED_CUSTOM_COMPONENTS = ["Image", "Link"];
export const MAX_JSX_DEPTH = 10;
export const EXCLUDED_FIELDS = ["children", "length"];
export const THEME_FONT_PREVIEW_ID = "__theme-font-preview";
